import Vue from "vue"

export class AuthenticationError extends Error {
  constructor(message) {
    super(message) // (1)
    this.name = "AuthenticationError" // (2)
  }
}

function normalizeErrorMessage(error) {
  const msg = error && error.message
  const is400 = msg && (msg.indexOf("Response not successful") !== -1 || msg.indexOf("status code 400") !== -1)
  if (is400) {
    const graphql = error.graphQLErrors && error.graphQLErrors[0]
    if (graphql && graphql.message) return graphql.message
    const net = error.networkError
    const resultErrors = net && net.result && net.result.errors && net.result.errors[0]
    if (resultErrors && resultErrors.message) return resultErrors.message
    return "A request to load data was rejected. Try refreshing the page. If it continues, check that the app and API versions match."
  }
  return msg || "An error occurred."
}

export const handleActionError = (error, commit) => {
  if (error instanceof AuthenticationError) {
    commit("updateSession", undefined)
    Vue.router.push("/")
  } else {
    const message = normalizeErrorMessage(error)
    commit("displayFlashMessage", { message, severity: "error" })
  }
}
